import { useEffect, useState } from 'react';
import { admin_api } from '@/lib/api';
import { toast } from 'sonner';
import { FloppyDisk } from '@phosphor-icons/react';

export default function AdminCMS() {
  const [items, setItems] = useState([]);
  const [drafts, setDrafts] = useState({});
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const res = await admin_api.contentList();
      setItems(res.items || []);
      const draft = {};
      (res.items || []).forEach(i => { draft[i.key] = i.value; });
      setDrafts(draft);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const save = async (item) => {
    try {
      await admin_api.contentUpsert(item.key, drafts[item.key], item.page, item.label || item.key);
      toast.success(`Updated ${item.key}`);
    } catch { toast.error('Could not save.'); }
  };

  const grouped = items.reduce((acc, i) => {
    const p = i.page || 'general';
    (acc[p] = acc[p] || []).push(i);
    return acc;
  }, {});

  return (
    <div data-testid="admin-cms">
      <div className="mb-8">
        <div className="overline mb-2">CMS</div>
        <h1 className="font-display font-extrabold text-3xl text-ink">Content editor</h1>
        <p className="text-ink-muted text-sm mt-1">Edit any content block used on the marketing site. Changes are live immediately after save.</p>
      </div>

      {loading && <div className="text-ink-muted">Loading…</div>}

      {Object.entries(grouped).map(([page, blocks]) => (
        <div key={page} className="mb-8 rounded-2xl bg-white border border-neutral-200 overflow-hidden">
          <div className="px-6 py-4 border-b border-neutral-100 flex items-center justify-between">
            <div>
              <div className="text-xs uppercase tracking-widest text-ink-muted font-semibold">Page</div>
              <div className="font-display font-bold text-ink text-lg">{page}</div>
            </div>
            <div className="text-sm text-ink-muted">{blocks.length} blocks</div>
          </div>
          <div className="divide-y divide-neutral-100">
            {blocks.map(b => (
              <div key={b.key} className="p-6 grid grid-cols-1 md:grid-cols-[240px_1fr_auto] gap-4 items-start">
                <div>
                  <div className="font-mono text-xs text-ink-muted">{b.key}</div>
                  <div className="text-sm text-ink font-medium mt-1">{b.label || b.key}</div>
                </div>
                <textarea
                  data-testid={`admin-cms-input-${b.key}`}
                  value={drafts[b.key] || ''}
                  onChange={e => setDrafts(d => ({ ...d, [b.key]: e.target.value }))}
                  rows={2}
                  className="input-base resize-none"
                />
                <button onClick={() => save(b)} data-testid={`admin-cms-save-${b.key}`} className="btn-primary !py-2 !px-4 text-xs">
                  <FloppyDisk size={14} weight="fill" /> Save
                </button>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
